import type { CSSProperties, RefObject } from 'react';
import { ProcessStepsCarouselMobileItem } from './item';
import type { ProcessStepsProps } from '../type';
import { defaultTitle, mobileScrollRunway } from '../constants';

function getCardTransform(index: number, globalProgress: number, count: number): CSSProperties {
  const local = index === 0 ? globalProgress + 1 : globalProgress - (index - 1);

  let translateY;
  let scale;

  if (local < 0) {
    translateY = 100;
    scale = 1;
  } else if (local < 1) {
    const t = 1 - Math.pow(1 - local, 3);
    translateY = 100 * (1 - t);
    scale = 1;
  } else {
    const depth = Math.min(local - 1, count);
    translateY = -depth * 6;
    scale = 1 - depth * 0.04;
  }

  return {
    transform: `translateY(${translateY}%) scale(${scale})`,
    zIndex: index + 1,
    transformOrigin: 'center top',
    willChange: 'transform',
  };
}

type ServerProps = ProcessStepsProps & {
  activeIndex?: number;
  progress?: number;
  totalHeight?: number;
  containerRef?: RefObject<HTMLDivElement | null>;
  stickyRef?: RefObject<HTMLDivElement | null>;
  onItemClick?: (index: number) => void;
};

export function ProcessStepsCarouselMobileServer({
  steps,
  title,
  activeIndex = 0,
  progress = 0,
  totalHeight,
  containerRef,
  stickyRef,
  onItemClick,
}: ServerProps) {
  const count = steps.content.data.length;
  const globalProgress = activeIndex + progress / 100;
  const runwayHeight = totalHeight === undefined ? mobileScrollRunway(count) : `${totalHeight}px`;

  return (
    <div ref={containerRef} style={{ height: runwayHeight }}>
      <div
        ref={stickyRef}
        className="sticky top-0 h-screen flex flex-col pt-8 pb-4 overflow-hidden box-border"
      >
        <h2
          className="section-title text-center text-brand-text-button pb-6 shrink-0 [&_i]:section-subtitle @md:[&_br]:hidden"
          dangerouslySetInnerHTML={{ __html: title || defaultTitle }}
        />

        <div className="relative flex-1 px-4">
          {steps.content.data.map((item, i) => (
            <div
              key={`${item.position}-${i}`}
              className="absolute inset-0"
              style={getCardTransform(i, globalProgress, count)}
            >
              <ProcessStepsCarouselMobileItem
                order={i + 1}
                title={item.title}
                subtitle={item.subtitle}
                image={item.image}
                onClick={onItemClick ? () => onItemClick(i) : undefined}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
